
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";

import DialogForm from "@/components/modal/DialogForm";
import { DeleteIcon } from "@/icons";
import DynamicForm from "@/pages/forms/MyComponent";
import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import FormikTextInput from "@/components/forms/FormikTextInput";
import { Form, Formik } from "formik";
import { Grid } from "@mui/material";
import ReusableButton from "@/components/buttons/StyledButton";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import { usePostLeaveSchemeMutation, useFetchLeaveSchemeQuery, useDeleteLeaveSchemeMutation } from "@/api/services/leaveManagement/LeaveTypeCategory"
import { toast } from "@/components/toastify";
import CustomAlert from "@/components/alert/CustomAlert";
import * as yup from "yup";

const validationSchema = yup.object({
  schemeName: yup.string().required("Scheme Name is required"),
  applicableTo: yup.string().required("Roll Type is required"),
  probationType: yup.string().required("Probation Type is required"),
});
const LeaveScheme = ({
  leaveScheme,
  setLeaveScheme,
}) => {

  const [openDelete, setOpenDelete] = useState(false);
  const [deleteValue, setDeleteValue] = useState(null);

  const [addScheme] = usePostLeaveSchemeMutation();
  const [deleteScheme] = useDeleteLeaveSchemeMutation();

  const { data: fetchRole, isLoading: roleLoading } =
    useFetchCommonData("SETTINGS", {
      name: "Role Of Intake",
      org: "ORG00001",
    });
  const { data: rowDetails = [], refetch } = useFetchLeaveSchemeQuery();
  const data = rowDetails?.data || [];

  const initialValues = {
    schemeName: "",
    applicableTo: "",
    probationType: "",
  };

  const SchemeActionButtons = ({ row, onDeleteClick }) => (
    <div>
      <Tooltip title="Delete">
        <DeleteIcon
          onClick={() => onDeleteClick(row)}
          style={{ cursor: "pointer", marginRight: 8 }}
        />
      </Tooltip>
    </div>
  );
  const schemeColumns = [
    { field: "schemeName", headerName: "Name", flex: 1 },
    { field: "applicableTo", headerName: "Role Type", flex: 1 },
    { field: "probationType", headerName: "Probation Status", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      renderCell: (params) => (
        <SchemeActionButtons
          row={params.row}
          onDeleteClick={() => handleDeleteClick(params.row)}
        />
      ),
    },
  ];

  const handleDeleteSubmit = async () => {
    try {
      await deleteScheme(deleteValue).unwrap();
      toast("success", "Leave  Scheme deleted successfully");
      // await refetch();
      setOpenDelete(false);
    } catch (error) {

    }
  };
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(false);
    try {
      const requestBody = {
        formName: "Scheme Name",
        formFields: values,

      };
      await addScheme({ formData: requestBody, org: "ORG00001" }).unwrap();
      toast("success", "Leave scheme added successfully");
      resetForm();

    } catch (error) {

    }
  };
  const handleDeleteClick = async (row) => {
    if (!row?.id) {

      return;
    }
    setDeleteValue(row.id);
    setOpenDelete(true);

  };






  return (
    <div>
      <DialogForm
        open={leaveScheme}
        setOpen={setLeaveScheme}
        title="Leave Scheme"
      >
        {/* Ensure data is passed correctly to the DataTable */}
        <CommonDataTable
          search={true}
          checkbox={false}
          columns={schemeColumns}
          rows={data} // Ensure `data` is passed here

        />
        <CustomAlert
          open={openDelete}
          title="Delete Leave Scheme"
          message="Are you sure you want to delete this  Leave Scheme?"
          onCancel={() => setOpenDelete(false)}
          onSubmit={handleDeleteSubmit}
          cancelText="Close"
          submitText="Delete"
        />
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {({ isSubmitting, resetForm }) => (
            <Form>
              <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid item xs={12}>
                  <FormikTextInput name="schemeName" label="Name" placeholder="Enter here" required={true} />
                </Grid>

                <Grid item xs={6}>
                  <FormikSelectInput name="applicableTo" label="Roll Type" options={fetchRole?.map((role) => ({ label: role.name, value: role.name }))} required={true} />
                </Grid>

                <Grid item xs={6}>
                  <FormikSelectInput name="probationType" label="Probation Type" options={[{ label: "Select", value: "" }, { label: "Extended", value: "extended" }, { label: "Trainee", value: "trainee" }, { label: "Confirmed", value: "confirmed" },{ label: "Probation", value: "probtaion" }]} required={true} />
                </Grid>
              </Grid>

              {/* Buttons */}
              <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
                <Grid item>
                  <ReusableButton onClick={() => setLeaveScheme(false)} label={"Cancel"} variant="outlined"></ReusableButton>
                </Grid>
                <Grid item>
                  <ReusableButton type="submit" variant="contained" label={"Save"} disabled={isSubmitting}></ReusableButton>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>

      </DialogForm>
    </div>
  );
};

export default LeaveScheme;
